__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "product-card-common";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("antd", "4.24.10", function() { return Promise.all([__webpack_require__.e(788), __webpack_require__.e(836), __webpack_require__.e(356)]).then(function() { return function() { return __webpack_require__(7788); }; }); });
			register("clsx", "1.2.1", function() { return __webpack_require__.e(106).then(function() { return function() { return __webpack_require__(106); }; }); });
			register("mobx-react", "7.6.0", function() { return Promise.all([__webpack_require__.e(31), __webpack_require__.e(836), __webpack_require__.e(488), __webpack_require__.e(356)]).then(function() { return function() { return __webpack_require__(8031); }; }); });
			register("mobx", "6.9.0", function() { return __webpack_require__.e(646).then(function() { return function() { return __webpack_require__(2646); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(423), __webpack_require__.e(836)]).then(function() { return function() { return __webpack_require__(3423); }; }); });
			register("react-router-dom", "6.13.0", function() { return Promise.all([__webpack_require__.e(10), __webpack_require__.e(836)]).then(function() { return function() { return __webpack_require__(5010); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(922).then(function() { return function() { return __webpack_require__(8922); }; }); });
			register("uuid", "8.3.2", function() { return __webpack_require__.e(406).then(function() { return function() { return __webpack_require__(3406); }; }); });
			initExternal(7454);
			initExternal(9018);
			initExternal(199);
			initExternal(7910);
			initExternal(1602);
			initExternal(9365);
			initExternal(4328);
			initExternal(9101);
			initExternal(7664);
			initExternal(236);
			initExternal(2111);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};